/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilitySettingValue
 */
export interface FacilitySettingValue {
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingValue
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingValue
     */
    setting_name: string;
    /**
     * 
     * @type {string}
     * @memberof FacilitySettingValue
     */
    value: string;
}

/**
 * Check if a given object implements the FacilitySettingValue interface.
 */
export function instanceOfFacilitySettingValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "setting_name" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function FacilitySettingValueFromJSON(json: any): FacilitySettingValue {
    return FacilitySettingValueFromJSONTyped(json, false);
}

export function FacilitySettingValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilitySettingValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'setting_name': json['setting_name'],
        'value': json['value'],
    };
}

export function FacilitySettingValueToJSON(value?: FacilitySettingValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
        'setting_name': value.setting_name,
        'value': value.value,
    };
}

